import { fromEvent } from 'rxjs'

export default fromEvent($(document), 'turbolinks:load')
